/**
 * @file: 工具
 */
import { vueMain } from '@/main.js'
import Setting from '@/setting';
let ws;
let connectWebSocket = function (uid) {
    // let websocketPath = Setting.websocketUrl + uid;
    let websocketPath = `${Setting.websocketUrl}/${uid}`;
    // websocketPath = websocketPath.replace('http://', 'ws://');
    ws = new WebSocket(websocketPath);

    // console.log(uid, 'uid');

    // 监听是否连接成功
    ws.onopen = function () {
        console.log('socket连接成功 !');
        // 连接成功则发送一个数据
        // ws.send('test1');
    }
    // 接听服务器发回的信息并处理展示
    ws.onmessage = function (msg) {
        console.log('收到消息 => ', msg);
        // vueMain.$bus.$emit('updatePageData', dataMessage);
        vueMain.$bus.$emit('updateNoticeMessage', msg.data);
    }
    // 监听连接关闭事件
    ws.onclose = function () {
        // 监听整个过程中websocket的状态
        if (ws) {
            ws.close();
            console.log("socket已断开连接");
        }
    }
    // 监听并处理error事件
    ws.onerror = function (error) {
        console.log('连接失败 error => ', error);
    }
}
export { connectWebSocket };